/* eslint-disable */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { setCookie } from '@browsing/utils';
import { USABILLA_BUTTON_ID, USABILLA_COOKIE, USABILLA_COOKIE_EXPIRATION_TIME_MS, } from './constants';
var getCampaignOptions = function (campaigns, label) {
    var campaignOption = campaigns === null || campaigns === void 0 ? void 0 : campaigns.find(function (c) { return c.campaignId === label; });
    return {
        cookieName: (campaignOption === null || campaignOption === void 0 ? void 0 : campaignOption.cookieName) || USABILLA_COOKIE,
        expirationDuration: (campaignOption === null || campaignOption === void 0 ? void 0 : campaignOption.expirationDuration) || USABILLA_COOKIE_EXPIRATION_TIME_MS,
    };
};
export var addUsabillaToWindow = function (_a) {
    var _b = _a === void 0 ? {} : _a, campaigns = _b.campaigns, auxiliaryData = _b.auxiliaryData, _c = _b.customVariables, customVariables = _c === void 0 ? {} : _c;
    if (typeof window === 'undefined') {
        return;
    }
    var ga = window.ga;
    if (!window.usabilla_live) {
        // prettier-ignore
        // NOSONAR
        // @ts-ignore - We need to ignore this line as it is a third party script
        window.lightningjs || function (c) { function g(b, d) { d && (d += "".concat(/\?/.test(d) ? "&" : "?", "lv=1")); c[b] || function () { var i = window; var h = document; var j = b; var g = h.location.protocol; var l = "load"; var k = 0; (function () { function b() { a.P(l); a.w = 1; c[j]("_load"); } c[j] = function () { function m() { m.id = e; return c[j].apply(m, arguments); } var b; var e = ++k; b = this && this != i ? this.id || 0 : 0; (a.s = a.s || []).push([e, b, arguments]); m.then = function (b, c, h) { var d = a.fh[e] = a.fh[e] || []; var j = a.eh[e] = a.eh[e] || []; var f = a.ph[e] = a.ph[e] || []; b && d.push(b); c && j.push(c); h && f.push(h); return m; }; return m; }; var a = c[j]._ = {}; a.fh = {}; a.eh = {}; a.ph = {}; a.l = d ? d.replace(/^\/\//, "".concat(g == "https:" ? g : "http:", "//")) : d; a.p = { 0: +new Date }; a.P = function (b) { a.p[b] = new Date - a.p[0]; }; a.w && b(); i.addEventListener ? i.addEventListener(l, b, !1) : i.attachEvent("on".concat(l), b); var q = function () { function b() { return ["<head></head><", c, ' onload="var d=', n, ";d.getElementsByTagName('head')[0].", d, "(d.", g, "('script')).", i, "='", a.l, "'\"></", c, ">"].join(""); } var c = "body"; var e = h[c]; if (!e)
            return setTimeout(q, 100); a.P(1); var d = "appendChild"; var g = "createElement"; var i = "src"; var k = h[g]("div"); var l = k[d](h[g]("div")); var f = h[g]("iframe"); var n = "document"; var p; k.style.display = "none"; e.insertBefore(k, e.firstChild).id = "".concat(o, "-").concat(j); f.frameBorder = "0"; f.id = "".concat(o, "-frame-").concat(j); /MSIE[ ]+6/.test(navigator.userAgent) && (f[i] = "javascript:false"); f.allowTransparency = "true"; l[d](f); try {
            f.contentWindow[n].open();
        }
        catch (s) {
            a.domain = h.domain, p = "javascript:var d=".concat(n, ".open();d.domain='").concat(h.domain, "';"), f[i] = "".concat(p, "void(0);");
        } try {
            var r = f.contentWindow[n];
            r.write(b());
            r.close();
        }
        catch (t) {
            f[i] = "".concat(p, "d.write(\"").concat(b().replace(/"/g, "".concat(String.fromCharCode(92), "\"")), "\");d.close();");
        } a.P(2); }; a.l && setTimeout(q, 0); })(); }(); c[b].lv = "1"; return c[b]; } var o = "lightningjs"; var k = window[o] = g(o); k.require = g; k.modules = c; }({}); // NOSONAR
        window.usabilla_live = window.lightningjs.require('usabilla_live', "//w.usabilla.com/".concat(USABILLA_BUTTON_ID, ".js"));
    }
    window.usabilla_live('data', {
        custom: __assign(__assign({}, customVariables), { auxiliaryData: auxiliaryData }),
    });
    window.usabilla_live('setEventCallback', function (category, action, label, value) {
        var _a = getCampaignOptions(campaigns, label), cookieName = _a.cookieName, expirationDuration = _a.expirationDuration;
        if (action === 'Campaign:Open') {
            var cookieExpirationTime = new Date(Date.now() + expirationDuration);
            setCookie(cookieName, 'true', { expires: cookieExpirationTime });
        }
        if (typeof ga !== 'undefined') {
            ga(function () {
                var trackerName = 'gtm2';
                ga("".concat(trackerName, ".send"), 'event', 'Usabilla Live', action, label, value, {
                    nonInteraction: true,
                });
            });
        }
    });
};
